import {UrlLink} from '../../../applink/UrlLink';
import {ColorMode} from '../../../colorMode/ColorMode.enum';
import {getEnv} from '../../../common/env/env';
import {ServerEnv} from '../../../common/env/ServerEnv.enum';
import {t} from '../../../common/getTranslations';
import {Divider} from '../../../design-system/atoms/Divider/Divider';
import {Icon} from '../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../design-system/atoms/Icon/IconType.enum';
import {Text} from '../../../design-system/atoms/Text/Text';
import {HeaderTitle} from '../../../design-system/organisms/HeaderTitle/HeaderTitle';
import {DeviceInfo} from '../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {theme} from '../../../theme';
import {COLOR_MODE_TEXT_MAP} from '../constant';

export interface SettingsProps {
  isMobile: boolean;
  colorMode?: ColorMode;
  ticketPopupOn?: boolean;
  tastesGenre: string;
  deviceInfo?: DeviceInfo;
  isDevBlockHidden: boolean;
  showDialog: () => void;
  showSelectTicketPopupOnDialog: () => void;
  showTasteGenreDialog: () => void;
  toggleDevBlockButton: () => void;
}

export const Settings = ({
  isMobile,
  colorMode,
  ticketPopupOn,
  tastesGenre,
  deviceInfo,
  isDevBlockHidden,
  showDialog,
  showSelectTicketPopupOnDialog,
  showTasteGenreDialog,
  toggleDevBlockButton,
}: SettingsProps) => {
  return (
    <>
      <div
        className="px-15pxr"
        {...putTiaraObjectProps({
          click: {layer1: '설정'},
        })}
      >
        {!isMobile && (
          <HeaderTitle className="mt-20pxr mb-32pxr">
            {t('common_setting')}
          </HeaderTitle>
        )}
        <div className="py-30pxr">
          <div className="font-small2 text-theme-solid-40">
            {t('more_settings_use')}
          </div>
          <div className="flex cursor-pointer py-20pxr" onClick={showDialog}>
            <Text className="font-medium2 flex-1 text-theme-solid-100">
              {t('more_settings_screen_type')}
            </Text>
            <div className="flex items-center">
              <Text className="font-x-small1 text-theme-solid-100">
                {COLOR_MODE_TEXT_MAP[colorMode as ColorMode]}
              </Text>
              <Icon type={IconType.ListArrowRight} />
            </div>
          </div>
          <Divider color={theme.colors['theme-transparent-10']} />
          <div
            className="flex cursor-pointer py-20pxr"
            onClick={showSelectTicketPopupOnDialog}
          >
            <Text className="font-medium2 flex-1 text-theme-solid-100">
              {t('more_settings_tickets')}
            </Text>
            <div className="flex items-center">
              <Text className="font-x-small1 text-theme-solid-100">
                {ticketPopupOn ? t('more_settings_on') : t('more_settings_off')}
              </Text>
              <Icon type={IconType.ListArrowRight} />
            </div>
          </div>
          <Divider color={theme.colors['theme-transparent-10']} />
          <div
            className="flex cursor-pointer py-20pxr"
            onClick={showTasteGenreDialog}
          >
            <Text className="font-medium2 flex-1 text-theme-solid-100">
              {t('more_settings_contents_recommendation_genre')}
            </Text>
            <div className="flex items-center">
              <Text className="font-x-small1 text-theme-solid-100">
                {tastesGenre === 'F'
                  ? t(
                      'more_settings_contents_recommendation_genre_romance_popup'
                    )
                  : t(
                      'more_settings_contents_recommendation_genre_fantasy_popup'
                    )}
              </Text>
              <Icon type={IconType.ListArrowRight} />
            </div>
          </div>
          <Divider
            color={theme.colors['theme-transparent-10']}
            className="mb-30pxr"
          />

          <div className="font-small2 text-theme-solid-40">
            {t('more_settings_device_info')}
          </div>
          <UrlLink url={'/device-management'}>
            <div
              className="flex cursor-pointer py-20pxr"
              onClickCapture={e => LOG_CLICK_EVENT('기기등록관리_클릭', e)}
            >
              <Text className="font-medium2 flex-1 text-theme-solid-100">
                {t('more_settings_device_register')}
              </Text>
              <div className="flex items-center">
                <Text className="font-x-small1 text-theme-solid-100">
                  {deviceInfo?.deviceList.length || 0}/
                  {deviceInfo?.deviceLimitCount || 0}
                </Text>
                <Icon type={IconType.ListArrowRight} />
              </div>
            </div>
          </UrlLink>
          <Divider color={theme.colors['theme-transparent-10']} />
          {getEnv().envName !== ServerEnv.Real && (
            <div className="mt-30pxr">
              <div className="font-small2 text-theme-solid-40">실험실</div>
              <div
                className="flex cursor-pointer py-20pxr"
                onClick={toggleDevBlockButton}
              >
                <Text className="font-medium2 flex-1 text-theme-solid-100">
                  페이지웹 개발자 도구
                </Text>
                <div className="flex items-center">
                  <Text className="font-x-small1 text-theme-solid-100">
                    {isDevBlockHidden ? 'OFF' : 'ON'}
                  </Text>
                  <Icon type={IconType.ListArrowRight} />
                </div>
              </div>
              <Divider color={theme.colors['theme-transparent-10']} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
